<script>
import appConfig from "@/app.config";
export default {
  computed:{
    getAppVersion(){
      return appConfig.version;
    }
  }
}
</script>
<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <!--{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © Diversitude.-->
        </div>
        <div class="col-sm-6">

          <div class="text-sm-end d-none d-sm-block">
            <span>
              Need help?
              <span class="text-primary me-4">support@diversitude.co.za</span>
            </span>
            <!--{{ new Date().getFullYear() }} © Powered by <a href="https://www.diversitude.com" target="_blank">Diversitude.</a></div>-->
            {{ new Date().getFullYear() }} © CCB IT - Powered by <a href="https://www.diversitude.com" target="_blank">Diversitude</a>
            <span class="ms-4">Version: {{getAppVersion}}</span>
          </div>

        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
